var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-box-button"},[_c('div',{staticClass:"hover-wrap",on:{"click":_vm.downLoad}},[_c('span',[_vm._v(_vm._s(_vm.download))]),_c('img',{attrs:{"src":require("../assets/images/main/download.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }